module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "toctitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01"
    }
  }, [_vm._v("Part One: The Paleo Way")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Chapter 1: Paleo 2.0")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec1"
    }
  }, [_vm._v("Jack LaLanne’s Story")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#sec2"
    }
  }, [_vm._v("Recent Paleo Research")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_vm._v("Chapter 2: The Truth about Saturated Fat")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec3"
    }
  }, [_vm._v("Saturated Fat, Blood Cholesterol Levels, and Heart Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec4"
    }
  }, [_vm._v("Saturated Fats Defined")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec5"
    }
  }, [_vm._v("Putting It All Together")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec6"
    }
  }, [_vm._v("Saturated Fats in Hunter-Gatherer Diets")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#sec7"
    }
  }, [_vm._v("Good and Bad Saturated Fats")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03"
    }
  }, [_vm._v("Chapter 3: Your Own Paleo Diet")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec8"
    }
  }, [_vm._v("Meal Timing the Paleo Way")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec9"
    }
  }, [_vm._v("Caloric Restriction, Longevity, and Health")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec10"
    }
  }, [_vm._v("Intermittent Fasting")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec11"
    }
  }, [_vm._v("Hunter-Gatherer Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec12"
    }
  }, [_vm._v("Fruit Guidelines")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec13"
    }
  }, [_vm._v("Domesticated versus Wild Produce")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec14"
    }
  }, [_vm._v("Organic versus Conventional Produce")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec15"
    }
  }, [_vm._v("Waxed Foods")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec16"
    }
  }, [_vm._v("Artificial Sweeteners")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter03#sec17"
    }
  }, [_vm._v("Cooking Advice for Contemporary Stone Agers")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Paleo Pitfalls")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Vegetarianism Can Be Hazardous to Your Health")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evolutionary Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Experimental Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetarian Diets and Nutritional Deficiencies")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Just Say No to the Milk Mustache")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dairy Advertising Hype")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evolutionary Clues")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dairy: A Nutritional Lightweight")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk, Ulcers, and Heart Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dairy and Heart Disease: Contemporary Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk, Insulin Resistance, and the Metabolic Syndrome")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk and Acne")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Is Filtered Cow’s Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unsafe Milk Hormones")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Allergies and Colic")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asthma and Excessive Mucus Production")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parkinson’s Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk and Cataracts")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Impairs Iron and Zinc Absorption")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk, Dairy, and Bone Health")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Grains Are Antinutritious")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phytate: One Antinutrient in Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Grains and Bone Health")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Grains Impair Vitamin D Metabolism")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole Grains and Celiac Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pseudo Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antinutrients in Seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Trouble with Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Toxicity of Uncooked Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nutrient Content of Beans and Legumes")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Purpose of Antinutrients")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lectins")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saponins")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phytate")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Polyphenols: Tannins and Isoflavones")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protease Inhibitors")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raffinose Oligosaccharides")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cyanogenetic Glycosides")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Favism Glycosides")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanuts and Heart Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Potatoes Should Stay below Ground")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Root and Tuber Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato Antinutrients")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#sec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saponins")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Food–Autoimmune Disease Connection")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autoimmune Diseases: Medical Science’s Black Box")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grains and Leaky Gut")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Leaky Gut Dietary Triggers")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lectin-Containing Foods")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saponins and Leaky Gut")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09#sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nightshades and Autoimmune Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Maximum Paleo Living")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Paleo Answer 7-Day Diet Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 7-Day Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Paleo Supplements and Sunshine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Folic Acid Supplementation and Fortification")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antioxidant Supplements Do More Harm than Good")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunshine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vitamin D Supplementation")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fish Oil Supplementation")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Paleo Water")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problems with Tap Water")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem with Plastic Bottled Water")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem with Plastics")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water for the Paleo Diet")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bottom Line for In-Home Water-Purification Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12#sec74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drinking Water Storage")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsparttitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: The Paleo Answer for Everyone")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Paleo Diet for Women")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protein and Pregnancy")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paleo Diets and Gestational Diabetes Mellitus")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Paleo Diet, Omega 3 Fatty Acids, and Pregnancy")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Paleo Diet and Polycystic Ovary Syndrome")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Paleo Diet and Breast and Other Cancers")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13#sec80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Paleo Diet and Osteoporosis")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Paleo Diet for Children")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paleo Diets during Infancy")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paleo Diets during Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Obesity Epidemic")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsh1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14#sec84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paleo Diets during the Teenage Years")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Reference",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "contentschaptertitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 57
// module chunks = 0